import React, { useContext, useEffect, useState } from 'react';
import ThumbUpOffAltIcon from '@mui/icons-material/ThumbUpOffAlt';
import ThumbDownOffAltIcon from '@mui/icons-material/ThumbDownOffAlt';
import ChatBotFeedbackNegative from './ChatBotFeedbackNegative';
import styled from '@emotion/styled';
import { Typography } from '@platform-ui/design-system';
import { SupportContext } from './SupportContext';
import {
  AmplitudeSupportDeflectionEvents,
  useAmplitude,
} from '../nav/hooks/useAmplitude';

const FeedbackContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: left;
  align-items: center;
  margin: 10px 0px;

  & > * {
    margin-left: 10px;
  }
`;
interface FeedbackOptionProps {
  selected: boolean;
}

const FeedbackOption = styled.span<FeedbackOptionProps>`
  cursor: pointer;
  color: ${({ selected }) => (selected ? 'rgba(13, 74, 195, 1)' : '#00000099')};

  &:hover {
    color: ${({ selected }) => (selected ? 'rgba(13, 74, 195, 1)' : 'black')};
  }
`;
enum FeedbackRate {
  Positive = 'positive',
  Negative = 'negative',
  Other = 'Other',
  Inaccurate = 'Inaccurate',
  Irrelevant = 'Irrelevant',
}

const ChatBotFeedback = () => {
  const { setChatBotFeedback } = useContext(SupportContext);
  const [feedbackType, setFeedbackType] = useState<FeedbackRate | ''>('');
  const [feedbackComments, setFeedbackComments] = useState<string>('');
  const { logEvent } = useAmplitude();

  const handleFeedback = (type: FeedbackRate) => {
    let rate;
    switch (type) {
      case FeedbackRate.Positive:
        rate = 10;
        break;
      case FeedbackRate.Negative:
        rate = 4;
        break;
      case FeedbackRate.Other:
        rate = 1;
        break;
      case FeedbackRate.Inaccurate:
        rate = 2;
        break;
      case FeedbackRate.Irrelevant:
        rate = 3;
        break;
      default:
        rate = 0;
    }

    const newFeedback = {
      rate,
      comments: feedbackComments,
    };
    setChatBotFeedback((prevFeedbackStack) => [
      newFeedback,
      ...prevFeedbackStack,
    ]);
    setFeedbackType(type);
  };

  useEffect(() => {
    if (feedbackType) handleFeedback(feedbackType);
  }, [feedbackComments, feedbackType]);

  const handleCheckboxChange = (comment: string) => {
    setFeedbackComments(Object.values(comment)[0]);
  };

  return (
    <>
      <FeedbackContainer>
        <Typography variant="label" color="#00000099">
          Was this helpful?
        </Typography>
        <FeedbackOption
          selected={feedbackType === FeedbackRate.Positive}
          onClick={() => {
            logEvent(AmplitudeSupportDeflectionEvents.PROVIDED_FEEDBACK, {
              Feedback: 'Positive',
            });
            handleFeedback(FeedbackRate.Positive);
          }}
        >
          <ThumbUpOffAltIcon />
        </FeedbackOption>
        <FeedbackOption
          selected={feedbackType === FeedbackRate.Negative}
          onClick={() => {
            logEvent(AmplitudeSupportDeflectionEvents.PROVIDED_FEEDBACK, {
              Feedback: 'Negative',
            });
            handleFeedback(FeedbackRate.Negative);
          }}
        >
          <ThumbDownOffAltIcon />
        </FeedbackOption>
      </FeedbackContainer>
      {feedbackType === FeedbackRate.Negative && (
        <ChatBotFeedbackNegative onCheckboxChange={handleCheckboxChange} />
      )}
    </>
  );
};

export default ChatBotFeedback;
